import { createEpicMiddleware } from 'redux-observable';

const epicMiddleware = createEpicMiddleware();

export default epicMiddleware;
